import React from "react";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Loader from "../progress-bar/Loader";
import SmallCardProject from "./overview/SmallCardProject";
import styled from "styled-components";
import {RedButtonReverse} from "../buttons/ButtonStyles";
import {loadDeletedProjects, restoreProject} from "./projects/projectsAction";
import {v4 as uuidv4} from 'uuid';
import {displayAlert} from "../../utils/utils";
import YesNoModal from "../modal/YesNoModal";

const ArchivedProjects = () => {

    const dispatch = useDispatch()
    const {isLoading, deletedProjects, message} = useSelector(state => state.deletedProjects)
    const {status: currentUserStatus} = useSelector(state => state.currentUser)

    const [isOpenModal, setIsOpenModal] = useState(false)
    const [idSelected, setIdSelected] = useState(0)
    const [errors, setErrors] = useState(false)
    useEffect(() => {
        if (currentUserStatus === 200) {
            dispatch(loadDeletedProjects())
        }
    }, [currentUserStatus, dispatch])


    const undeletedProject = async (id) => {
        try {
            await dispatch(restoreProject(id))
            dispatch(loadDeletedProjects())
            setIsOpenModal(false)
        } catch (e) {
            setErrors(true)
            setIsOpenModal(false)
        }
    }

    const openModal = (state, id) => {
        setIsOpenModal(state)
        setIdSelected(id)
    }

    const displayModal = () => {
        if (isOpenModal) {
            return (
                <YesNoModal
                    handleClickYesAction={undeletedProject}
                    id={idSelected}
                    isDeleteAction={false}
                    title={" Êtes-vous sûr de vouloir désarchiver le projet"}
                    setOpenModal={setIsOpenModal}
                />
            )
        }
    }




    const displayProjects = () => {
        if (isLoading) {
            return <Loader/>
        } else {
            if (deletedProjects.length === 0) {
                return <h2 className={"w-100 txt-align"}> Aucun projet n'a encore été supprimé </h2>
            } else {
                return (
                    <Projects>
                        {deletedProjects.map(p => (
                            <Project
                                key={uuidv4()}
                            >
                                <SmallCardProject
                                    id={p.id}
                                    referenceCode={p.referenceCode}
                                    name={p.name}
                                    pilot={p.pilot}
                                    weather={p.weather}
                                    advancement={p.advancement}
                                    lastUpdate={p.lastUpdate}
                                    projectId={p.id}
                                    canBeEdited={false}
                                    endDate={p.endDate}
                                    startDate={p.startDate}
                                    confidential={p.confidential}
                                />

                                <Button onClick={() => openModal(true, p.id)}><p> Désarchiver </p></Button>
                            </Project>
                        ))}
                    </Projects>
                )
            }
        }
    }
    return (
        <Container>
            {displayAlert(errors, message==="restored")}
            {displayModal()}
            <h1> Projets archivés</h1>
            <p> Retrouvez ici les projets supprimés dans les 30 derniers jours. </p>
            {displayProjects()}
        </Container>

    )
}


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`
const Projects = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;

  .small-project-card {
    width: 350px;
  }

  @media (min-width: 1200px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .small-project-card {
      width: unset;
    }
  }
`

const Project = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Button = styled(RedButtonReverse)`
  width: 50%;
  align-self: center;
  padding: 0.2rem;
`
export default ArchivedProjects